import React from 'react';
import { Button, Field, Input } from '@billda/design-system';
import { useLabourItemUIStore } from '../stores/labourItemUIStore';
import { useCreateLabourDefinition } from '../hooks/useLabourDefinitionMutations';

const ItemCreatePanel: React.FC = () => {
  const addItemFormName = useLabourItemUIStore(state => state.addItemFormName);
  const setAddItemFormName = useLabourItemUIStore(
    state => state.setAddItemFormName
  );
  const closePanel = useLabourItemUIStore(state => state.closePanel);

  const createMutation = useCreateLabourDefinition();

  const handleConfirmAdd = () => {
    createMutation.mutate(addItemFormName, {
      onSuccess: () => closePanel(),
    });
  };

  const handleCancel = () => {
    closePanel();
  };

  return (
    <div className="p-5 sm:p-6" data-testid="item-create-content">
      <div className="flex flex-col gap-6">
        <Field
          label="Labour item name"
          hint="Use the name workers will recognise when booking."
          required
        >
          <Input
            autoFocus
            type="text"
            value={addItemFormName}
            onChange={e => setAddItemFormName(e.target.value)}
            disabled={createMutation.isPending}
            data-testid="add-item-input"
          />
        </Field>

        <div className="flex gap-3 border-t border-border-default pt-4">
          <Button
            variant="ghost"
            onClick={handleCancel}
            disabled={createMutation.isPending}
            fullWidth
            data-testid="add-item-cancel"
          >
            Cancel
          </Button>
          <Button
            variant="neutral"
            onClick={handleConfirmAdd}
            disabled={!addItemFormName.trim() || createMutation.isPending}
            loading={createMutation.isPending}
            fullWidth
            data-testid="add-item-confirm"
          >
            Add labour item
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ItemCreatePanel;
